App.RestaurantsController = Em.Controller.extend
  session: Em.inject.service()

  restaurantsBinding:   'model'

  selectedGroup:         -1 # если null, то развернутся рестораны без города
  filterDisabled: (->
    @get('cities').length < 2 && @get('brands').length < 2
  ).property('cities.length','brands.length')

  cities: Em.computed(
    'restaurants',
    'selectedGroup', ->
      _this = @
      _cities = []
      _cities_had = []
      @get('restaurants.content').forEach (el) ->
        city_name = el.get('city')?.toLowerCase()
        if _cities_had.indexOf(city_name) == -1 && el.get('noParent')
          _cities_had.push city_name
          _cities.push({
            name: city_name,
            id: city_name,
            is_selected: city_name == _this.get('selectedGroup')
          })

      _cities.sort (_a,_b) ->
        return -1 unless _a.name
        return 1 unless _b.name

        a = _a.name?.toLowerCase()
        b = _b.name?.toLowerCase()
        return 1 if a > b
        return -1 if a < b

        return 0
  )

  brands: (->
    @get('session.availableOrganizations').map (v) =>
      {
        name: v.get('name'),
        id: v.get('id'),
        is_selected: v.get('id') == @get('selectedGroup')
      }
  ).property('session.availableOrganizations[]', 'selectedGroup')

  groups: (->
    if @get('session.isLC')
      @get('brands')
    else
      @get('cities')
  ).property('cities','brands','session.availableOrganizations')

  visibleRestaurants: Em.computed(
    'filterDisabled',
    'selectedGroup',
    'session.currentOrganization',
    'restaurants', ->

      _this = @

      if @get('session.isLC')
        return @get('restaurants') if _this.get('filterDisabled')

        return @get('session.availableOrganizations')
          .filter((o) => o.get('id') == _this.get('selectedGroup'))
            .get('firstObject.restaurants')

      @get('restaurants.content')

      .sort (_a,_b) ->
        a = _a.get('city')?.toLowerCase()
        b = _b.get('city')?.toLowerCase()
        return 1 if a > b
        return -1 if a < b

        a = _a.get('name')?.toLowerCase()
        b = _b.get('name')?.toLowerCase()
        return 1 if a > b
        return -1 if a < b

        return 0

      .filter (el) ->
        el.get('noParent') &&
        (_this.get('filterDisabled') || el.get('city')?.toLowerCase() == _this.get('selectedGroup')?.toLowerCase())

  )

  organization:         Em.computed.alias('session.currentOrganization')
  isEditing:            false


  actions:
    changeSelectedGroup: (group) ->
      @set('selectedGroup', group)
